
<template>
    <div :class="parent ? 'careai__themed-tree' : ''">
        <div class="careai__themed-tree--toolbar" v-if="searchEnabled">
            <b-form-group
                id="input-group-1"
                label="Filter Items:"
                label-for="input-label"
                description="Searches keys & values."
                >
                <b-form-input
                    id="input-label"
                    v-model="searching"
                    type="text"
                    placeholder="Key / Value"
                    required
                ></b-form-input>
            </b-form-group>
        </div>
        <ul :class="parent ? 'careai__themed-tree--ul' : ''">
            <li v-for="(value, key) in transformedData" :key="`themed-table-${randomKey}-${key}`">
                <div class="careai__themed-tree--node">
                    <span v-if="['object'].includes(typeof(value))" style="margin-top: 5px; margin-right: 15px; cursor: pointer; position: absolute; left: -20px; top: -5px;" @click="collapsed = !collapsed;">
                        <span :class="isCollapsed ? 'careai__themed-tree--caret careai__themed-tree--caret__collapsed' : 'careai__themed-tree--caret'">▼</span>
                    </span>
                    <b>{{ searchMatch }} {{ key }}:</b> 
                    <template v-if="!['object'].includes(typeof(value))">
                        {{ value }} 
                    </template>
                    <template v-else>
                        <careai-tree-node
                            v-if="!collapsed"
                            :items="value"
                            :searching="searchingValue"
                            :parent="false"
                        />
                    </template>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
  import Vue from "vue";
    /**
     * Formats a collapsible and searchable tree to the specification set. All in standard CareAI theme.
     * 
     * @property items { } Any object. Iterates values. String values display as is and objects and array values iterate downstream until complete.
     */
    const Tree = {
        name: "ThemedTree",
        components: {},
        props: {
            items: {
                type: Object,
                default: function () {
                    return {};
                },
            },
            searchEnabled: {
                type: Boolean,
                default: function () {
                    return false;
                },
            },
            searching: {
                type: String,
                default: function () {
                    return "";
                }
            },
            parent: {
                type: String,
                default: function () {
                    return true;
                }
            },
        },
        data() {
            return {
                console: console,
                randomKey: (Math.random() + 1).toString(36).substring(36),
                collapsed: false,
            };
        },
        watch: {

        },
        computed: {
            isCollapsed() {
                return this.collapsed;
            },
            searchingValue() {
                return this.searching;
            },
            transformedData() {
                return this.transformData(this.items);
            }
        },
        methods: {
            transformData(data) {
                let response = {};
                if (this.parent && this.searchingValue && this.searchingValue.length) {
                    response = this.filterJson(data, this.searchingValue);
                } else {
                    response = data;
                }
                return response;
            },
            filterJson(data, search) {
                const lowerSearch = search.toLowerCase();
                if (Array.isArray(data)) {
                    const filteredArray = data
                    .map(item => this.filterJson(item, search))
                    .filter(item =>
                        item !== undefined &&
                        (typeof item !== 'object' ||
                        (Array.isArray(item) ? item.length : Object.keys(item).length))
                    );
                    return filteredArray.length ? filteredArray : undefined;
                } else if (data && typeof data === 'object') {
                    const result = {};
                    for (const key in data) {
                        if (!data.hasOwnProperty(key)) continue;
                        const value = data[key];
                        const keyMatches = key.toLowerCase().includes(lowerSearch);
                        if (keyMatches) {
                            result[key] = value;
                        } else if (value !== null && typeof value === 'object') {
                            const filteredValue = this.filterJson(value, search);
                            if (
                            filteredValue !== undefined &&
                            (Array.isArray(filteredValue)
                                ? filteredValue.length
                                : Object.keys(filteredValue).length)
                            ) {
                                result[key] = filteredValue;
                            }
                        } else {
                            const strValue = String(value).toLowerCase();
                            if (strValue.includes(lowerSearch)) {
                                result[key] = value;
                            }
                        }
                    }
                    return Object.keys(result).length ? result : undefined;
                } else {
                    return String(data).toLowerCase().includes(lowerSearch) ? data : undefined;
                }
            }
        },
    };

    Vue.component('careai-tree-node', Tree);

    export default Tree;
</script>

<style lang="scss">
.careai__themed-tree {
    .careai__themed-tree--toolbar{
        background-color: #f7f7f7;
        border: 1px solid #dee2e6;
        padding: 15px;
    }

    * {
        color: #5f5f5f;
        position: relative;
        margin: 0;
        font-size: 14px;
    }
    .careai__themed-tree--ul {
        margin: 0;
        padding: 15px;
        margin: 15px;
        margin-top: 0px;
    }
    ul {
        list-style: none;
        > * li {
            margin-top: 5px;
            margin-left: 30px;
            color: #8c8c8c;
        }

        strong, b {
            font-weight: 500;
        }

        .careai__themed-tree--caret {
            display: inline-block;
            cursor: pointer;
            -webkit-touch-callout: none; 
            -webkit-user-select: none; 
            -moz-user-select: none; 
                -ms-user-select: none; 
                    user-select: none; 
            transform: scaleY(.5);
        }

        .careai__themed-tree--caret__collapsed {
            transform: rotate(-90deg) scaleY(.5);
        }
    }
}
</style>

